if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.shareTitle = this.dataset.shareTitle || document.title;
        this.directCopyButton = this.querySelector('.smart-share__copy');
        this.directCopyStatus = this.querySelector('.smart-share__status');

        this.directCopyButton?.addEventListener('click', this.copyDirectLink.bind(this));
        this.updateSocialLinks();

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      copyDirectLink() {
        navigator.clipboard
          .writeText(this.urlToShare)
          .then(() => {
            if (this.directCopyStatus) this.directCopyStatus.textContent = 'Link copied to clipboard';
            this.directCopyButton?.classList.add('is-copied');
            window.setTimeout(() => {
              this.directCopyButton?.classList.remove('is-copied');
              if (this.directCopyStatus) this.directCopyStatus.textContent = '';
            }, 2400);
          })
          .catch(() => {
            if (this.directCopyStatus) this.directCopyStatus.textContent = 'Copy failed. Use the Share button instead.';
          });
      }

      updateSocialLinks() {
        const encodedUrl = encodeURIComponent(this.urlToShare);
        const encodedTitle = encodeURIComponent(this.shareTitle);
        const links = {
          whatsapp: `https://wa.me/?text=${encodeURIComponent(`${this.shareTitle} ${this.urlToShare}`)}`,
          facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
          x: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
        };

        Object.entries(links).forEach(([channel, url]) => {
          const link = this.querySelector(`[data-share-channel="${channel}"]`);
          if (link) link.href = url;
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
        this.updateSocialLinks();
      }
    }
  );
}
